import { type ParameterShape, renderTypeUsage } from '@/core/utils/mappers/formatTypeUsage'

export type ArrayLiteralBrackets = { open: string; close: string; separator: string }

export function getArrayBrackets(technology: string, elementDisplay: string): ArrayLiteralBrackets {
  switch (technology) {
    case 'nuget':
      return { open: `new ${elementDisplay || 'object'}[] { `, close: ' }', separator: ', ' }
    case 'maven':
      return { open: `new ${elementDisplay || 'Object'}[] { `, close: ' }', separator: ', ' }
    case 'npm':
    case 'pypi':
    case 'ruby':
    case 'packagist':
    default:
      return { open: '[', close: ']', separator: ', ' }
  }
}

export function getNestedElementDisplay(shape: ParameterShape, technology: string): string {
  if (shape.kind !== 'array') return ''
  if (!shape.elementTypeUsage) return ''
  return renderTypeUsage(shape.elementTypeUsage, technology)
}
